export const Vogue = "https://email.helloyumi.com/assets/_homepage/Vogue.svg";
export const NYT = "https://email.helloyumi.com/assets/_homepage/NYT.svg";
export const Goop = "https://email.helloyumi.com/assets/_homepage/Goop.svg";
export const FoodAndWine =
  "https://email.helloyumi.com/assets/_homepage/FoodAndWine.svg";
export const Eating =
  "https://email.helloyumi.com/assets/_TotsLanding/TotsLanding_Eating.png";
export const DarkBlue = "#324599";
export const BabyBlue = "#668FCA";
